import API from "./API";

export default class Maps extends API {
  constructor(gateway) {
    super(gateway, 'map')
  }
}
